import React, { useState } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { Link } from "react-router-dom";
const UserManagement = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullWidthWrapper, setFullWidthWrapper] = useState();
  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullWidthWrapper(isActivated ? "fullwrapper" : "");
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullWidthWrapper}>
        <Header onclick={handleToggle} />
        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-people"></i> Customer Admin
              </li>
              <li>
                <span className="breadcrumb_slash">/</span> <i className="bi bi-app-indicator mx-2"></i> Invoice
              </li>
            </ul>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="filter_header fs-12 lh-14">
              <div className="row">
                <div className="col-lg-4">
                  <div className="d-flex gap-1">
                    <div className="search_box">
                      <input type="text" className="w-100 form-control" />
                    </div>
                    <div className="search_button">
                      <button className="btn btn-outline-light border text-dark py-0 fs-12 fw-600">
                        <i className="bi bi-search me-1"></i>Search
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 fw-700 ps-4">
                  <div className="d-flex align-items-center gap-2">
                    <div className="col-md-1">
                      <label htmlFor="">From</label>
                    </div>
                    <div className="col-md-4">
                      <select className="form-select form-select-sm" name="" id="">
                        <option value=""></option>
                        <option value="">20/02/2024</option>
                        <option value="">14/01/2024</option>
                        <option value="">31/12/2023</option>
                        <option value="">15/04/2020</option>
                      </select>
                    </div>
                    <div className="col-md-1 ms-3 text-end">
                      <label htmlFor="">To</label>
                    </div>
                    <div className="col-md-4">
                      <select className="form-select form-select-sm" name="" id="">
                        <option value=""></option>
                        <option value="">20/02/2024</option>
                        <option value="">14/01/2024</option>
                        <option value="">31/12/2023</option>
                        <option value="">15/04/2020</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="d-flex  justify-content-end mt-3 mt-lg-0">
                    <Link to="">
                      <button className="btn btn-success   py-0 fs-12 fw-600">
                        <i class="bi bi-file-earmark-medical"></i> Download all
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive mt-3">
              <table className="table fs-14 lh-20">
                <thead className="table-light  fs-12 lh-16  border-top">
                  <tr>
                    <th>Invoice</th>
                    <th>Date of Invoice</th>
                    <th>Amount billed</th>
                    <th>Payment Status</th>
                    <th>Document</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>#212475</td>
                    <td>20/03/2023</td>
                    <td>₹ 24500</td>
                    <td>Pending</td>

                    <td className="fs-16">
                      <i class="bi bi-file-earmark-medical"></i>
                    </td>
                  </tr>
                  <tr>
                    <td>#212475</td>
                    <td>20/03/2023</td>
                    <td>₹ 24500</td>
                    <td>Pending</td>

                    <td className="fs-16">
                      <i class="bi bi-file-earmark-medical"></i>
                    </td>
                  </tr>
                  <tr>
                    <td>#212475</td>
                    <td>20/03/2023</td>
                    <td>₹ 24500</td>
                    <td>Pending</td>

                    <td className="fs-16">
                      <i class="bi bi-file-earmark-medical"></i>
                    </td>
                  </tr>
                  <tr>
                    <td>#212475</td>
                    <td>20/03/2023</td>
                    <td>₹ 24500</td>
                    <td>Pending</td>

                    <td className="fs-16">
                      <i class="bi bi-file-earmark-medical"></i>
                    </td>
                  </tr>
                  <tr>
                    <td>#212475</td>
                    <td>20/03/2023</td>
                    <td>₹ 24500</td>
                    <td>Pending</td>

                    <td className="fs-16">
                      <i class="bi bi-file-earmark-medical"></i>
                    </td>
                  </tr>
                  <tr>
                    <td>#212475</td>
                    <td>20/03/2023</td>
                    <td>₹ 24500</td>
                    <td>Pending</td>

                    <td className="fs-16">
                      <i class="bi bi-file-earmark-medical"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserManagement;
